import DatePicker from "react-datepicker";
import React, { useRef, useState } from "react";
import { ReactComponent as RightArrow } from "../../assets/images/icons/RightArrow.svg";

import { createPortal } from "react-dom";
import BasicSelect from "./BasicSelect";
import moment from "moment";
import { flattenTree } from "../../utils/utilityFunctions/stringUtility";
import { convertTimeToDateObj, getFlushedDate } from "../../utils/utilityFunctions/dateUtility";
import DelegationMultiSelect from "./DelegationMultiSelect";
import InputComponent from "./../UniversalComponents/InputComponent";
import SelectComponent from "./../UniversalComponents/SelectComponent";
import TextAreaComponent from "./../UniversalComponents/TextAreaComponent";
import DatePickerComponent from "./../UniversalComponents/DatePickerComponent";
import TimePickerComponent from "./../UniversalComponents/TimePickerComponent";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import { createOption } from "../../utils/api/customTemplatesApi";
import { useLazyFetchFieldValuesQuery } from "../../utils/customer/customerSelect";
import { sub } from "date-fns";

const roundUpToNextHalfHour = (time) => {
  // Extract hours and minutes from the input time
  const [hours, minutes] = time.split(":").map(Number);

  // Calculate the next half-hour mark
  const roundedMinutes = minutes < 30 ? 30 : 0;
  const roundedHours = minutes < 30 ? hours : (hours + 1) % 24;

  // Format hours and minutes into HH:MM with seconds always set to 00
  return `${String(roundedHours).padStart(2, "0")}:${String(roundedMinutes).padStart(2, "0")}:00`;
};

const generateTimeOptions = () => {
  const times = [];
  for (let i = 0; i < 24; i++) {
    const hour = i < 10 ? `0${i}` : i;
    times.push(`${hour}:00:00`);
    times.push(`${hour}:30:00`);
  }
  return times;
};

const FieldElements = ({
  id,
  name,
  InputEndIcon,
  label,
  value,
  onChange,
  placeholder,
  size = 1,
  disabled,
  isFormDisabled,
  selectionList,
  type,
  inputType = "text",
  formData = {},
  taskid,
  defaultOptions,
  dynamicOptions,
  apiCall,
  addButton,
  addButtonLabel,
  addButtonAction,
  isLoading,
  useFetchHook = () => {},
  hookPayload,
  noKeyboardNavigation,
  noDisabled,
  displayValueKey,
  displayName,
  updateTags,
  clickTrigger,
  isNegativeValue = false,
  className = "",
  labelKey = "label",
  valueKey = "value",
  sublabelKey = "sublabel",
  valueKeyBased,
  handleGroupsValue,
  mandatory = false,
  apiCallParam,
  onClick,
  isChecked,
  fetchAndSetFieldOptions = () => {},
  ...props
}) => {
  const [fetchFieldValues, { data: fieldValueList, isFetching: isFieldFetching }] = useFetchHook() || [() => {}, {}];

  const dispatch = useDispatch();

  const optionList = defaultOptions || dynamicOptions;
  // ||
  // fieldValueList?.data?.map((item) =>
  //   !valueKeyBased ? { label: item, value: item, color_code: item?.color } : { label: item[labelKey], value: item[valueKey], color_code: item?.color }
  // );
  const handleCallHook = () => {
    if (fetchFieldValues && Boolean(hookPayload)) {
      fetchFieldValues({ payload: hookPayload }, true);
    }
  };

  console.log(formData[name], optionList, "formDatainfieldelments");
  const handleFieldOptionAdd = async (optionData, OldOtion) => {
    try {
      let body = {
        value: optionData.value,

        ...(OldOtion?.value && { id: OldOtion?.value }),
      };

      if (optionData?.color_code) {
        body = {
          value: optionData?.value,
          color: optionData?.color_code,

          ...(OldOtion?.value && { id: OldOtion.value }),
        };
      }
      const response = await createOption({ query: { field_name: name }, body });

      if (response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );
        await fetchAndSetFieldOptions({ value: name });
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });
  };

  switch (type) {
    case "select":
      return (
        <BasicSelect
          options={optionList || []}
          selectedOptions={flattenTree(optionList || [])?.filter((eachOption) => {
            if (typeof eachOption === "object" && eachOption !== null) {
              return JSON.stringify(formData[name])?.toLowerCase() === JSON.stringify(eachOption.value)?.toLowerCase();
            } else {
              return String(formData[name])?.toLowerCase() === String(eachOption.value)?.toLowerCase();
            }
          })}
          onChange={onChange}
          showSearch={optionList?.length > 5}
          disabled={(disabled || isFormDisabled) && !noDisabled}
          id={id}
          name={name}
          value={value}
          displayValue={formData[name]?.label}
          label={label}
          apiCall={apiCall}
          apiCallParam={apiCallParam}
          dynamicOptions={dynamicOptions}
          isLoading={isLoading || isFieldFetching}
          addButton={addButton}
          addButtonLabel={addButtonLabel}
          addButtonAction={addButtonAction}
          useFetchHook={useFetchHook}
          handleCallHook={hookPayload && handleCallHook}
          noKeyboardNavigation={noKeyboardNavigation}
          // isOpen,onClose,ref,showSearch,name,value,onClick,id,disabled,selectedOptions,options
          className={`form-select rounded border ${isFormDisabled || disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0`}
        />
      );
    case "dropdown":
      return (
        <BasicSelect
          options={optionList || []}
          selectedOptions={[formData[name]]}
          onChange={(e) => onChange({ target: { name, value: e.target.valueObj } })}
          showSearch={optionList?.length > 5}
          disabled={(disabled || isFormDisabled) && !noDisabled}
          id={id}
          name={name}
          value={value}
          displayValue={formData[displayValueKey]}
          label={label}
          apiCall={apiCall}
          apiCallParam={apiCallParam}
          dynamicOptions={dynamicOptions}
          isLoading={isLoading || isFieldFetching}
          addButton={addButton}
          addButtonLabel={addButtonLabel}
          addButtonAction={addButtonAction}
          useFetchHook={useFetchHook}
          handleCallHook={hookPayload && handleCallHook}
          noKeyboardNavigation={noKeyboardNavigation}
          // isOpen,onClose,ref,showSearch,name,value,onClick,id,disabled,selectedOptions,options
          className={`form-select rounded border ${isFormDisabled || disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0`}
        />
      );
    case "date":
      return (
        <div className="flex relative w-full custom-datepicker-container">
          <DatePickerComponent
            selected={getFlushedDate(formData[name])}
            id={id}
            name={name}
            value={formData?.[name] ? new Date(formData[name]) : null}
            onChange={(selectedDate) => {
              const formattedDate = selectedDate ? moment(selectedDate).format("YYYY-MM-DD") : null;
              onChange({ target: { name, value: formattedDate } });
            }}
            popperContainer={({ children }) => createPortal(children, document.getElementById("portal-root"))}
            dateFormat="dd-MM-yyyy"
            placeholder={placeholder || "Select Date"}
            className="custom-select bg-white rounded-sm focus:outline-hidden focus:ring-0 focus:border-1D5D9B w-full"
            maxDate={new Date("2050-01-01")}
            minDate={new Date("2001-01-01")}
            showYearDropdown
            showMonthDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={500}
            popperPlacement="bottom-end"
            size={"small"}
            innerClassName="h-[30px]"
          />
        </div>
      );
    case "multiselect":
      return (
        <SelectComponent
          options={optionList || []}
          value={formData[name]}
          onChange={(e) => onChange({ target: { name, value: e.target.valueObj } })}
          showSearch={optionList?.length > 5}
          disabled={(disabled || isFormDisabled) && !noDisabled}
          id={id}
          apiCall={apiCall}
          valueKey="id"
          name={name}
          multiSelect
          // displayValue={formData[name]?.map((val) => val.label).toString()}
          label={label}
          // isOpen,onClose,ref,showSearch,name,value,onClick,id,disabled,selectedOptions,options
          className={`form-select rounded border ${isFormDisabled || disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0`}
        />
      );
    case "multi_person":
      return (
        <SelectComponent
          options={optionList || []}
          value={formData[name]}
          onChange={(e) => onChange({ target: { name, value: e.target.valueObj } })}
          showSearch={optionList?.length > 5}
          disabled={(disabled || isFormDisabled) && !noDisabled}
          id={id}
          apiCall={apiCall}
          valueKey="uuid"
          sublabelKey="email"
          labelKey="name"
          personList
          name={name}
          multiSelect
          // displayValue={formData[name]?.map((val) => val.label).toString()}
          label={label}
          // isOpen,onClose,ref,showSearch,name,value,onClick,id,disabled,selectedOptions,options
          className={`form-select rounded border ${isFormDisabled || disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0`}
        />
      );
    case "person":
      return (
        <SelectComponent
          options={optionList || []}
          value={formData[name]}
          onChange={(e) => onChange({ target: { name, value: e.target.valueObj } })}
          showSearch={optionList?.length > 5}
          disabled={(disabled || isFormDisabled) && !noDisabled}
          id={id}
          apiCall={apiCall}
          valueKey="uuid"
          sublabelKey="email"
          labelKey="name"
          personList
          name={name}
          // displayValue={formData[name]?.map((val) => val.label).toString()}
          label={label}
          // isOpen,onClose,ref,showSearch,name,value,onClick,id,disabled,selectedOptions,options
          className={`form-select rounded border ${isFormDisabled || disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0`}
        />
      );
    case "time":
      return (
        <>
          <TimePickerComponent
            id={name}
            name={name}
            value={formData?.[name] ? convertTimeToDateObj(formData[name]) : null}
            onChange={(date) => {
              console.log(date, "helllloinputtt 1");
              const formattedTime = date ? formatTime(date) : null;
              onChange({ target: { name, value: formattedTime } });
            }}
            placeholder="Select Time"
            size="medium"
            popperContainer={({ children }) => createPortal(children, document.getElementById("portal-root"))}
          />
          {console.log(formData, "hellloformmmmm")}
        </>
      );
    case "text":
      return (
        <InputComponent
          type={inputType}
          id={id}
          name={name}
          value={value}
          onChange={(e) => onChange(e)}
          isDisabled={isFormDisabled}
          inputClassName={` h-[30px] text-xs`}
          placeholder={placeholder ? placeholder : "Select Text"}
          mandatory={mandatory}
          icon={InputEndIcon}
        />
      );
    case "hours":
      return (
        <div className="w-[50%] rounded-md">
          <InputComponent
            type="number"
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            isDisabled={isFormDisabled}
            inputClassName={` h-[30px] text-xs`}
            min="0"
            showArrow
          />
        </div>
      );
    case "tags":
      return (
        <div className="w-full">
          <SelectComponent
            options={optionList || []}
            value={formData[name]}
            onChange={(e) => onChange({ target: { name, value: e.target.valueObj } })}
            showSearch={optionList?.length > 5}
            disabled={(disabled || isFormDisabled) && !noDisabled}
            id={id}
            apiCall={apiCall}
            name={name}
            multiSelect
            addButton
            addButtonLabel="Add New Tag"
            isEditList
            addButtonAction={(val) => handleFieldOptionAdd(val)}
            editListHandler={(val, val2) => handleFieldOptionAdd(val2, val)}
            inlineCrud
            // displayValue={formData[displayValueKey] ?? displayName}
            // displayValue={formData[name]}

            label={label}
            // isOpen,onClose,ref,showSearch,name,value,onClick,id,disabled,selectedOptions,options
            className={`form-select rounded border ${isFormDisabled || disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0`}
          />
        </div>
      );
    case "number":
      return (
        <div className="w-full rounded-md">
          <input
            type="number"
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            disabled={(disabled || isFormDisabled) && !noDisabled}
            className={`rounded-md border h-9 border-DFE2E5 text-434852 text-xs block w-full focus:outline-hidden focus:ring-0 p-2 ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"}`}
            {...(!isNegativeValue && { min: 0 })}
          />
        </div>
      );
    case "file":
      return (
        <input
          type="file"
          id={id}
          name={name}
          disabled={(disabled || isFormDisabled) && !noDisabled}
          // placeholder="Enter Subject"
          value={value}
          onChange={onChange}
          className={` rounded border ${isFormDisabled || disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"}  focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5  text-xs block w-full `}
        />
      );
    case "textArea":
      return (
        <TextAreaComponent
          type="textArea"
          id={id}
          name={name}
          value={value}
          onChange={(e) => onChange(e)}
          className={`text-xs cursor-pointer ${className}`}
          placeholder={placeholder ? placeholder : "Enter Text Here..."}
          mandatory={mandatory}
        />
      );
    case "radio":
      return (
        <div className="flex gap-4 my-1">
          {optionList?.map((option) => (
            <label key={option?.value} className="flex items-center gap-x-2 text-xs cursor-pointer">
              {console.log(value, option.value, "radiovalueVinay")}
              <input
                type="radio"
                id={`${name}-${option.value}`}
                name={name}
                value={option.value}
                checked={String(isChecked).toLowerCase() === String(option.value).toLowerCase()}
                onChange={(e) => onChange(e)}
                disabled={(disabled || isFormDisabled) && !noDisabled}
                className="checked:bg-primary-90 checked:border-primary cursor-pointer ring-0 focus:ring-0 outline-none"
              />
              {option?.label}
            </label>
          ))}
        </div>
      );
    case "assigned_to":
      return (
        <div className="basis-5/5 col-span-1">
          <DelegationMultiSelect
            noLabel
            formData={formData}
            isFormDisabled={props?.isFormDisabled}
            isSearchBarOpen={props?.isSearchBarOpen}
            taskassignedtoref={props?.taskassignedtoref}
            handleMouseEnter={props?.handleMouseEnter}
            handleMouseLeave={props?.handleMouseLeave}
            handleCheck={props?.handleCheck}
            personTableData={props?.personTableData || []}
            handleSelectPerson={props?.handleSelectPerson}
            handleRemovePerson={props?.handleRemovePerson}
            searchTerm={props?.searchTerm}
            isEditTask={props?.isEditTask}
            depth="D0"
            personCountAllowed={1}
            className="font-600"
          />
        </div>
      );
    case "displayValue":
      return (
        <div
          onClick={onClick}
          className={`${className}flex justify-between items-center text-xs border rounded-md border-DFE2E5 bg-gray-100 text-434852 w-full p-2 cursor-pointer`}
        >
          {value}
          <RightArrow />
        </div>
      );
    default:
      break;
  }
};

export default FieldElements;
